module.exports = __webpack_public_path__ + "static/media/pp_regular_paper_straw_black2.9f62d699.png";